import $ from 'jquery';

export default function(done){

  var styles = `
    <style type="text/css">

      @import url("https://fast.fonts.net/lt/1.css?apiType=css&c=02924fe0-55b2-4c25-ba8c-b9ab4491b39a&fontids=1604568");

      @font-face{
          font-family:"Helvetica Neue LT W06_85 Heavy";
          src:url("asset/FS-WebFonts-576793922/Fonts/1604568/8a90a2ba-1276-4b3f-bc1c-8526172b27f4.eot?#iefix");
          src:url("asset/FS-WebFonts-576793922/Fonts/1604568/8a90a2ba-1276-4b3f-bc1c-8526172b27f4.eot?#iefix") format("eot"),
              url("asset/FS-WebFonts-576793922/Fonts/1604568/c415f3fd-ff27-40fe-af94-8b4a54b4b4e4.woff2") format("woff2"),
              url("asset/FS-WebFonts-576793922/Fonts/1604568/a1da20c7-4dc9-4af5-bd6f-9ebe50b6788d.woff") format("woff"),
              url("asset/FS-WebFonts-576793922/Fonts/1604568/d97d6994-a426-43f8-a392-2870e4cc705f.ttf") format("truetype");
      }

    </style>
  `

  $('head').append(styles)

  var temp =
    $('<div>')
    .css({
      fontSize: '50px',
      color: 'white',
      display: 'inline-block',
      opacity: 0,
    })
    .html('!"§$%&/()=#+-')

  $('body').append(temp)

  var w = temp.width()
  var h = temp.height()

  temp
  .css({
    fontFamily: 'Helvetica Neue LT W06_85 Heavy'
  })

  var start = new Date()

  var check = function(){
    // console.log('w', temp.width(), 'h', temp.height())
    var now = new Date()
    var duration = now - start
    requestAnimationFrame(function(){
      if(temp.width() != w || temp.height() != h || duration > 2000){
        temp.remove()
        done()
      } else {
        check()
      }
    })
  }

  check()

}



// WEBPACK FOOTER //
// ./src/client/lib/preloadFont.js